import { apiService } from '../../../shared/services/apiService';
import {
  CustomerInbodyTypeOption,
  GetInbodyIndicatorsResponse,
  ScanService,
  UpdateScansFromInbodyResponse,
} from './types';
import { apiStatusStore } from '../../../shared/stores/apiStatusStore';
import { ManualScanData } from '../../interfaces/customerInbodyData';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { KeyBodyMetricsInfo } from '../../interfaces/keyBodyMetricsInfo';

export const scanIqScanService: ScanService = {
  async getInbodyIndicators(
    customerId: number,
    userInbodyType: InbodyType | 'ALL',
    entityId: number,
  ) {
    const resp = await apiService.post<GetInbodyIndicatorsResponse>(
      `/api/scan-iq/customers/${customerId}/inbody-data`,
      { userInbodyType },
      { params: { entityId } },
    );
    return resp.data;
  },

  async getCustomerInbodyTypeOptions(customerId: number, entityId: number) {
    const resp = await apiService.get<CustomerInbodyTypeOption[]>(
      `api/scan-iq/customers/${customerId}/inbody-types`,
      { params: { entityId } },
    );
    return resp.data;
  },

  async getScanDates(customerId: number, entityId: number) {
    const resp = await apiService.get<ScanMetadata[]>(
      `api/scan-iq/customers/${customerId}/scan-dates`,
      { params: { entityId } },
    );
    return resp.data;
  },

  async getKeyBodyMetrics(customerId: number, entityId: number) {
    const resp = await apiService.get<KeyBodyMetricsInfo>(
      `api/coach/scan-iq/customers/${customerId}/stats/body-metrics`,
      { params: { entityId } },
    );
    return resp.data;
  },

  async updateScansFromInbody(customerId: number, entityId?: number) {
    const resp = await apiService.put<UpdateScansFromInbodyResponse>(
      `/api/scan-iq/customers/${customerId}/inbody/scan/upload`,
      undefined,
      { params: { entityId } },
    );

    return resp.data;
  },

  // Unavailable APIs - throw Error and show message
  async getMealPlansOnScanDay(customerId: number) {
    const errorMessage = `Meal plans are not available for SCAN_IQ customers ${customerId}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },

  async getScanDateByInbodyId(inbodyId: number | string) {
    const errorMessage = `Inbody device data is not available for SCAN_IQ customers ${inbodyId}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },

  async createScanManually(customerId: number, scanDate: ManualScanData) {
    const errorMessage = `Manual scan creation is not available for SCAN_IQ customers ${customerId} ${scanDate}`;
    apiStatusStore.addErrorMessage(errorMessage);
    throw new Error(errorMessage);
  },
};
